<template>
  <div>
    <b-modal
      id="isshowReview"
      size="sm"
      centered
      hide-header
      modal-content-classes="cust-modal-ht-wo cust-overflow-y-grey"
      hide-footer
      class="overflow-y-hidden"
    >
      <div class="text-center text-black fsize25px font-medium header-font">
        <h1 class="col-black sm-fsize20">Your opinion matters to us!</h1>
      </div>
      <div class="mx-4">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <div>
            <!-- <label>Activity form</label> -->
          </div>
          <el-input
            type="textarea"
            placeholder="Leave a message,if you want"
            width="50px"
            rows="5"
            v-model="description"
            class="justify-center bg-f3f3f3"
          >
          </el-input>
        </el-form>
        <div class="text-center fsize20px font-medium text-opax pt-4">
          <h1 class="fsize15 sm-fsize14">Rate our Experience with the Service provider !</h1>
        </div>
        <b-form-rating
          id="rating-inline"
          inline-value="4"
          size="sm"
          v-model="value"
          color="#f3ca63"
          class="border-none w-1/2 m-auto mb-4"
        ></b-form-rating>
        <div class="rate-btn flex justify-center mt-4">
          <b-button variant="primary" @click="handleRate()">Rate Now</b-button>
        </div>
      </div>

      <div class="border-footer pt-6"></div>

      <div
        class="text-center text-opax letter-space fsize20px font-semibold"
        style="cursor: pointer"
        @click="$bvModal.hide('isshowReview')"
      >
        <p><b>May be later</b></p>
      </div>

      <template slot="footer"> <div></div> </template>
    </b-modal>

    <div class="booking-head fsize25px mb-8">
      <h1><b class="col-black">My Bookings</b></h1>
    </div>
    <el-table :data="get_allbookingvol.result" style="width: 100%">
      <el-table-column
        prop="volunteerId.userId.firstname"
        label="Name"
        width="200"
      >
        <template v-slot="{ row }" class="">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.volunteerId ? row.volunteerId.userId.firstname : "" }}
            {{ row.volunteerId ? row.volunteerId.userId.lastname : "" }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        prop="text"
        label="Service Required"
        width="200"
        class="text-center"
        v-slot="{ row }"
      >
        {{ row.volunteerId ? row.volunteerId.service : "-" }}
      </el-table-column>
      <el-table-column
        prop="date"
        label="Date"
        sortable=""
        width="190"
        v-slot="{ row }"
      >
        {{
          new Date(row.date).toLocaleDateString("en-IN", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })
        }}</el-table-column
      >
      <el-table-column prop="time" label="Time" width="190"></el-table-column>
      <el-table-column
        prop="status"
        label="Status"
        width="200"
      ></el-table-column>
      <el-table-column
        prop="date2"
        label="Completed On"
        width="190"
        v-slot="{ row }"
      >
        {{
          row.completedOn
            ? new Date(row.completedOn).toLocaleDateString("en-IN", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })
            : "-"
        }}</el-table-column
      >

      <el-table-column label="Review" width="200">
        <template slot-scope="scope">
          <p
            v-if="scope.row.status == 'Completed'"
            v-b-modal.isshowReview
            type="text"
            class="px-2 underline fsize14 text-gray"
            size=""
            @click="handleSubmit(scope)"
          >
            Write a Review
          </p>
        </template>
      </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        @change="handlePageChange"
        :per-page="perPage"
        :total="total_row"
      ></base-pagination>
    </b-card-footer>
  </div>
</template>

<script>
import { Table, TableColumn } from "element-ui";
import moment from "moment";
import { mapState } from "vuex";
export default {
  name: "light-table",
  components: {
    moment,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      ruleForm: {
        desc: "",
      },
      value: null,
      description: "",
      tableData: [
        {
          Name: "sahil",
          text: "caregiver",
          date: "22/01/2022",
          time: "10:00",
          status: "completed",
          date2: "25/01/2022",
        },
        {
          Name: "sumit",
          text: "caregiver",
          date: "22/01/2022",
          time: "10:00",
          status: "completed",
          date2: "25/01/2022",
        },
        {
          Name: "yash",
          text: "caregiver",
          date: "22/01/2022",
          time: "10:00",
          status: "completed",
          date2: "25/01/2022",
        },
      ],
      rules: {
        desc: [
          {
            required: true,
            message: "Please select activity resource ",
            trigger: "change",
          },
        ],
      },

      currentPage: 1,
      perPage: 10,
      row: {},
      total_row: 5,
    };
  },
  methods: {
    formatter(row, column) {
      return row.address;
    },
    async init() {
      let payload = {
        _id: this.user._id,
        limit: 10,
        offset: (this.currentPage - 1) * 10,
      };
      let loader = this.$loading();
      try {
        let data = await this.$store.dispatch(
          "respitecare/get_allbooking",
          payload
        );
        // console.log(data);
        this.total_row = this.get_allbookingvol.totalCount;
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    async handlePageChange(value) {
      this.currentPage = value;
      try {
        this.init();
      } catch (error) {}
    },
    async handleSubmit(scope) {
      this.row = scope.row;
      // console.log(this.row);
    },
    async handleRate() {
      let payload = {
        review: this.description,
        rating: this.value,
        userId: this.user._id,
        volunteerId: this.row.volunteerId._id,
      };
      if (this.description != "") {
        try {
          let data = await this.$store.dispatch(
            "respitecare/createreview",
            payload
          );
          this.$swal.fire({
            title: "Thanks for rating",
            // text: err,
            icon: "success",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          this.row = {};
          this.description = "";
          this.value = "";
          this.$bvModal.hide("isshowReview");
        } catch (err) {
          this.$swal.fire({
            title: "Something went wrong",
            text: err,
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
      } else {
        this.$swal.fire({
          title: "Add a message",
          // text: err,
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
      }
    },
    getDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
  },
  computed: {
    ...mapState("auth", { user: "user" }),
    ...mapState("respitecare", { get_allbookingvol: "get_allbookingvol" }),

    // displayedPages() {
    //   return this.get_allbookingvol.slice(
    //     (this.currentPage - 1) * this.perPage,
    //     this.currentPage * this.perPage
    //   );
    // },
  },
  async mounted() {
    await this.init();
  },
};
</script>

<style>
.el-table th > .cell {
  text-align: center;
  color: #000;
}
.el-table .cell {
  text-align: center;
}
.fsize25px {
  font-size: 25px;
}
.fsize20px {
  font-size: 20px;
}
.border-review-modal {
  border: 1px solid #eeedee;
  border-radius: 20px;
}
.space-border {
  padding: 18px 21px;
}
.text-opax {
  color: black;
  opacity: 80%;
}
.bg-f3f3f3 .el-textarea__inner {
  background: #f3f3f3;
}
.border-footer {
  border-bottom: 1px solid#f3f4f5;
}
.letter-space {
  padding: 10px 20px;
}
.header-font {
  padding: 13px 9px;
}
</style>
